export enum StatusP2PTransfer {
  Pending = 1,
  Acepted = 2,
  Rejected = 3,
  ParcialAcepterd = 4,
  Canceled = 5,
}

export const StatusP2POption = [
  { id: StatusP2PTransfer.Pending, name: 'Pendiente' },
  { id: StatusP2PTransfer.Acepted, name: 'Aceptado' },
  { id: StatusP2PTransfer.Rejected, name: 'Rechazado' },
  { id: StatusP2PTransfer.ParcialAcepterd, name: 'Aceptado Parcial' },
  { id: StatusP2PTransfer.Canceled, name: 'Cancelado' },
];
export const StatusP2POptionVerbo = [
  { id: StatusP2PTransfer.Pending, name: 'Pendiente(s)' },
  { id: StatusP2PTransfer.Acepted, name: 'Aceptadas(s)' },
  { id: StatusP2PTransfer.Rejected, name: 'Rechazada(s)' },
  { id: StatusP2PTransfer.ParcialAcepterd, name: 'Aceptada(s) Parcial' },
  { id: StatusP2PTransfer.Canceled, name: 'Cancelado(s)' },
];
